// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.2";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';

Sentry.init({
	dsn: 'https://14d94d0da835adfefc960a0e3a0ae505@o4509429635547136.ingest.de.sentry.io/4509429643214928',

	// Add optional integrations for additional features
	integrations: [
		Sentry.replayIntegration(),
		Sentry.feedbackIntegration({
			colorScheme: 'light',
			autoInject: false,
			environment: process.env.SENTRY_ENVIRONMENT,
		}),
	],

	// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
	tracesSampleRate: 1,

	// Define how likely Replay events are sampled.
	// This sets the sample rate to be 10%. You may want this to be 100% while
	// in development and sample at a lower rate in production
	replaysSessionSampleRate: 0,

	// Define how likely Replay events are sampled when an error occurs.
	replaysOnErrorSampleRate: 0,

	// Setting this option to true will print useful information to the console while you're setting up Sentry.
	debug: false,

	// Add default tags to all events
	initialScope: {
		tags: {
			service: 'direct',
		},
	},
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
